import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsOptional, Length } from 'class-validator';
import { CreateEmpresaDto } from './create-empresa.dto';

export class CreateEmpresaFullDto extends CreateEmpresaDto {
  @ApiProperty({ example: 'admin_empresa', description: 'Username para el usuario admin de la empresa' })
  @IsNotEmpty({ message: 'Usuario es obligatorio' })
  @Length(3, 50, { message: 'Usuario debe tener entre 3 y 50 caracteres' })
  usuario: string;

  @ApiProperty({ example: '123456', description: 'Password del usuario admin' })
  @IsNotEmpty({ message: 'Password es obligatorio' })
  @Length(6, 100, { message: 'Password debe tener al menos 6 caracteres' })
  password: string;

  @ApiProperty({ example: 'Juan', description: 'Nombres del usuario admin', required: false })
  @IsOptional()
  @Length(2, 100, { message: 'Nombres debe tener entre 2 y 100 caracteres' })
  nombres_usuario?: string;
}
